import { render, staticRenderFns } from "./reviewTable.vue?vue&type=template&id=a861b7f6"
import script from "./reviewTable.vue?vue&type=script&lang=ts"
export * from "./reviewTable.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports